<form [formGroup]="officeForm">

    <div class="modal-header">
        <h4 class="modal-title ">Añadir / Modificar Entidad</h4>

    </div>
    <div class="modal-body">
        <div class="row">
            <div class="mt-2 col-lg-7 col-md-12 col-xs-12">
                Nombre Contratante / Empresa <small class="text-danger"></small>
                <input type="text" class="form-control" formControlName="name" name="name" placeholder="Nombre Empresa">
            </div>
            <div class="mt-2 col-lg-2 col-md-4 col-xs-6">
                RUT<small class="text-danger"></small>
                <input type="text" class="form-control" formControlName="rut" name="rut" placeholder="Rut Empresa" (blur)="setDV()">
            </div>
            <div class="mt-2 col-lg-1 col-md-4 col-xs-6">
                DV <small class="text-danger"></small>
                <label class="form-control">{{!officeForm.value.dv ? "-" : officeForm.value.dv | uppercase}}</label>
            </div>
           
            <div class="mt-4 col-lg-2 col-md-4 col-xs-12 d-flex align-items-center">
                <div class="form-check form-switch">
                    <input #checkActive class="form-check-input" type="checkbox" role="switch" id="checkActive" formControlName="enabled">
                    <label class="form-check-label" for="checkActive">Activo</label>
                </div>
            </div>
        </div>
       
    </div>
    <div class="modal-footer mt-3">
        <button class="btn btn-outline-danger btn-sm mx-3" (click)="cancel()"> Cancelar</button>
        <!-- @if(permissions?.search.save){ -->
        <button class="btn btn-primary btn-sm" [disabled]="officeForm.invalid" (click)="submit()"> Guardar</button>
        <!-- } -->
    </div>


</form>